<div [innerHTML]="diffHtml" class="text-diff w-100"></div>
